export const environment = {
    production: true,
    test: false,
    apiBaseUrl: 'https://api.doktar.io',
    demoUrl: 'https://www.cropmap.com/demo',
    appId: '5269dbb2-5d09-4108-8241-9d367346b180',
    sentryDsn: '',
};
